import { FormatDate } from "commonFunctions/commonFunctions";
import React, { useMemo } from "react";
import { RenderEpicMessage, RenderOnbaseMessage } from "./RenderMessages";

const OrderTable = (props) => {

    return <table>
        <tr>
            <th>ID</th>
            <th>Date</th>
            <th>Order Name</th>
            {props.isKeyPresent(props.data, "onbase_confirmation") && <th style={{ textAlign: "center", width: "150px" }}>Readabl Upload to Onbase Status</th>}
            {props.isKeyPresent(props.data, "epic_confirmation") && <th style={{ textAlign: "center" }}>EPIC Status</th>}
        </tr>
        {Object.values(props.data).map((ord, i) => (
            <tr key={i}>
                <td>{ord.identifier}</td>
                <td>{ord.authoredOn && FormatDate({ date: ord.authoredOn, format: "MM/DD/YYYY" })}</td>
                <td>{ord.code}</td>
                {ord.onbase_confirmation && <td><RenderOnbaseMessage data={ord} /></td>}
                {ord.epic_confirmation && <td><RenderEpicMessage data={ord} /></td>}
            </tr>
        ))}
    </table>
}

export default OrderTable;